const listItemStyle={
    color: "inherit",
  
    borderRadius:"8px",

    "&.active": { color: "#000000 !important",borderRadius:"10px", backgroundColor:"#000000e6",
    "& .myIconClass, & .MuiTypography-root": {
      color: "#000000"
    } },

    "&:hover": {
      color: "#dedede",
      backgroundColor: "#524F45",
      "& .myIconClass, & .MuiTypography-root": {
        color: "#dedede"
      }
    }
  }
  const buttonStyle={
    
  
  // "&:hover": {
  //   color: "#dedede",
  //   backgroundColor: "#524F45",
  //   "& .myIconClass, & .MuiTypography-root": {
  //     color: "#dedede"
  //   }
  // }
  }

  export {listItemStyle,buttonStyle}